import layout from '@/components/common/layout';
import classroomList from '../views/classroom/list';
import classroomCreate from "../views/classroom/create";

export default [
    {
        path: '/classroom',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "教室列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'classroom_list',// 子选项
                    }
                },
                component: classroomList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增教室",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'classroom_list',// 子选项
                    }
                },
                component: classroomCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑教室",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'classroom_list',// 子选项
                    }
                },
                component: classroomCreate,
            },
        ]
    },
];
